window.JE_COMPAT_DEVICES = {
  ios: {
    Apple: [
      // iPhones
      'iPhone 17',
      'iPhone 17 Air',
      'iPhone 17 Pro',
      'iPhone 17 Pro Max',
      'iPhone 16',
      'iPhone 16 Plus',
      'iPhone 16 Pro',
      'iPhone 16 Pro Max',
      'iPhone 15',
      'iPhone 15 Plus',
      'iPhone 15 Pro',
      'iPhone 15 Pro Max',
      'iPhone 14',
      'iPhone 14 Plus',
      'iPhone 14 Pro',
      'iPhone 14 Pro Max',
      'iPhone 13',
      'iPhone 13 Mini',
      'iPhone 13 Pro',
      'iPhone 13 Pro Max',
      'iPhone 12',
      'iPhone 12 Mini',
      'iPhone 12 Pro',
      'iPhone 12 Pro Max',
      'iPhone 11',
      'iPhone 11 Pro',
      'iPhone 11 Pro Max',
      'iPhone XS',
      'iPhone XS Max',
      'iPhone XR',
      'iPhone SE (2020)',
      'iPhone SE (2022)',
      // iPads — WiFi+Cellular models only
      'iPad Pro 11-inch (M4)',
      'iPad Pro 13-inch (M4)',
      'iPad Pro 11-inch (M2)',
      'iPad Pro 12.9-inch (M2)',
      'iPad Air 11-inch (M2)',
      'iPad Air 13-inch (M2)',
      'iPad Air 5th Gen (WiFi+Cellular)',
      'iPad Air 4th Gen (WiFi+Cellular)',
      'iPad Air 3rd Gen',
      'iPad mini 7th Gen',
      'iPad mini 6th Gen',
      'iPad mini 5th Gen',
      'iPad 10th Gen',
      'iPad 9th Gen',
      'iPad 8th Gen',
      'iPad 7th Gen',
      // Apple Watch — Cellular models only
      'Apple Watch Ultra 2',
      'Apple Watch Ultra',
      'Apple Watch Series 9 (Cellular)',
      'Apple Watch Series 8 (Cellular)',
      'Apple Watch Series 7 (Cellular)',
      'Apple Watch Series 6 (Cellular)',
      'Apple Watch Series 5 (Cellular)',
      'Apple Watch Series 4 (Cellular)',
      'Apple Watch SE 2nd Gen (Cellular)',
      'Apple Watch SE (Cellular)'
    ]
  },
  android: {
    Samsung: [
      // Galaxy S Series
      'Galaxy S25',
      'Galaxy S25+',
      'Galaxy S25 Ultra',
      'Galaxy S25 Edge',
      'Galaxy S24',
      'Galaxy S24+',
      'Galaxy S24 Ultra',
      'Galaxy S24 FE',
      'Galaxy S23',
      'Galaxy S23+',
      'Galaxy S23 Ultra',
      'Galaxy S22',
      'Galaxy S22+',
      'Galaxy S22 Ultra',
      'Galaxy S21',
      'Galaxy S21+',
      'Galaxy S21 Ultra',
      'Galaxy S20',
      'Galaxy S20+',
      'Galaxy S20 Ultra',
      // Galaxy Z Fold
      'Galaxy Z Fold 6',
      'Galaxy Z Fold 5',
      'Galaxy Z Fold 4',
      'Galaxy Z Fold 3',
      'Galaxy Z Fold 2',
      // Galaxy Z Flip
      'Galaxy Z Flip 6',
      'Galaxy Z Flip 5',
      'Galaxy Z Flip 4',
      'Galaxy Z Flip 3',
      'Galaxy Z Flip',
      // Galaxy Note
      'Galaxy Note 20',
      'Galaxy Note 20 Ultra',
      // Galaxy Tab — 5G/LTE models only
      'Galaxy Tab S10+ (5G)',
      'Galaxy Tab S10 Ultra (5G)',
      'Galaxy Tab S9 (5G)',
      'Galaxy Tab S9+ (5G)',
      'Galaxy Tab S9 Ultra (5G)'
    ],
    Google: [
      'Pixel 9',
      'Pixel 9 Pro',
      'Pixel 9 Pro XL',
      'Pixel 9 Pro Fold',
      'Pixel 8',
      'Pixel 8 Pro',
      'Pixel 8a',
      'Pixel 7',
      'Pixel 7 Pro',
      'Pixel 7a',
      'Pixel 6',
      'Pixel 6 Pro',
      'Pixel 6a',
      'Pixel 5',
      'Pixel 5a',
      'Pixel 4',
      'Pixel 4 XL',
      'Pixel 4a',
      'Pixel 4a 5G'
    ],
    Motorola: [
      'Razr (2019)',
      'Razr 5G',
      'Razr (2022)',
      'Razr 40',
      'Razr 40 Ultra',
      'Razr 50 Ultra',
      'Razr Plus (2026)',
      'Razr Ultra (2026)',
      'Edge 40',
      'Edge 40 Pro',
      'Edge 40 Neo',
      'Edge (2022)',
      'Edge (2023)'
    ],
    OnePlus: [
      'OnePlus 11',
      'OnePlus 12',
      'OnePlus 13',
      'OnePlus 13R',
      'OnePlus 13T',
      'OnePlus 15',
      'OnePlus Open'
    ],
    Sony: [
      'Xperia 1 IV',
      'Xperia 1 V',
      'Xperia 1 VI',
      'Xperia 1 VII',
      'Xperia 5 IV',
      'Xperia 5 V',
      'Xperia 10 III Lite',
      'Xperia 10 IV',
      'Xperia 10 V',
      'Xperia 10 VI',
      'Xperia Ace III'
    ],
    Oppo: [
      'Find X3',
      'Find X3 Pro',
      'Find X5',
      'Find X5 Pro',
      'Find X6 Pro',
      'Find X7',
      'Find X8',
      'Find X9',
      'Find X9 Pro',
      'Find N2',
      'Find N3',
      'Find N5',
      'Reno 5A',
      'Reno 9A',
      'Reno 11',
      'Reno 13',
      'Reno 14',
      'Reno 15'
    ],
    Huawei: [
      'P40',
      'P40 Pro',
      'Nova 6',
      'Nova 6 5G',
      'Mate 40',
      'Mate 40 Pro',
      'Pura 70 Pro'
    ],
    Vivo: [
      'X90 Pro',
      'X100',
      'X100 Pro',
      'X200',
      'X200 Pro',
      'X200s',
      'X300',
      'V29',
      'V29 Lite',
      'V29 Lite 5G',
      'V40',
      'V40 SE'
    ],
    Xiaomi: [
      'Redmi Note 11 Pro 5G',
      'Redmi Note 13 Pro',
      'Redmi Note 13 Pro+',
      'Redmi Note 14 Pro 5G',
      'Redmi Note 14 Pro+',
      'Redmi Note 14 Pro+ 5G',
      'Redmi Note 15 Pro 5G'
    ],
    Nothing: [
      'Nothing Phone (2)',
      'Nothing Phone (3a)',
      'Nothing Phone (3a) Pro'
    ]
  }
};
